var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "job-fuzzy-matrix--value-group" }, [
    _vm.category.label
      ? _c("div", { staticClass: "job-fuzzy-matrix--value-group-label" }, [
          _vm._v(_vm._s(_vm.category.label))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "job-fuzzy-matrix--values" },
      _vm._l(_vm.values, function(value) {
        return _c("Value", {
          key: value.id,
          attrs: { row: _vm.row, value: value },
          on: {
            filter: function($event) {
              return _vm.$emit("filterValue", $event)
            }
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }